/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { TagValueTypeFromJSON, TagValueTypeToJSON, } from './TagValueType';
/**
 * Check if a given object implements the TagResponse interface.
 */
export function instanceOfTagResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "valueType" in value;
    isInstance = isInstance && "predefinedValuesOnly" in value;
    return isInstance;
}
export function TagResponseFromJSON(json) {
    return TagResponseFromJSONTyped(json, false);
}
export function TagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'predefinedValues': !exists(json, 'predefinedValues') ? undefined : json['predefinedValues'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'valueType': TagValueTypeFromJSON(json['valueType']),
        'predefinedValuesOnly': json['predefinedValuesOnly']
    };
}
export function TagResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'predefinedValues': value.predefinedValues,
        'metaData': MetaDataToJSON(value.metaData),
        'valueType': TagValueTypeToJSON(value.valueType),
        'predefinedValuesOnly': value.predefinedValuesOnly
    };
}
